import {http} from './index';
import {ListApi,SaveQuickReplyApi} from '../types';
export const getListApi = (params:ListApi) => http.get('/teaching-workbench/qa/user/qr/list',params);
export const saveQuickReplyApi = (params:SaveQuickReplyApi) => http.post('/teaching-workbench/qa/user/qr/save',params);
export const deleteQuickReplyApi = (rsId:number) => http.delete(`/teaching-workbench/qa/user/qr/content/${rsId}`);
export const getStatisticsListApi = () => http.get('/teaching-workbench/qa/user/qr/project');
